<template>
  <default-layout>
    <div class="pa-4">
      <otp formType="page" />
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import Otp from '@/components/auth/otp';
import { mapState } from 'vuex';

import DefaultHeadMixin from '@/mixins/defaultHead';

export default {
  mixins: [DefaultHeadMixin],
  components: {
    DefaultLayout,
    Otp,
  },
  computed: {
    ...mapState({}),
  },
  methods: {},
  mounted() {},
};
</script>
